// Compare page — "Recently viewed" strip storage.
//
// Purely client-side: the last players SELECTED ON THIS PAGE, max 8, newest
// first, in localStorage. No backend involvement (noted in the PR).

const KEY = "tp.compare.recentPlayers";
const MAX = 8;

export const readRecentPlayers = () => {
  try {
    const raw = window.localStorage.getItem(KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list.slice(0, MAX) : [];
  } catch (e) {
    return [];
  }
};

export const pushRecentPlayer = (player) => {
  if (!player || player.id === null || player.id === undefined) return;
  try {
    const entry = {
      id: player.id,
      name: player.name || "",
      shortName: player.shortName || player.name || "",
      imageUrl: player.imageUrl || null,
      club: player.club || null,
      clubImage: player.clubImage || null,
      position: player.position || null,
      positionCode: player.positionCode || null,
      age: player.age ?? null,
    };
    const list = readRecentPlayers().filter((p) => p.id !== entry.id);
    list.unshift(entry);
    window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch (e) {
    // storage full/blocked — the strip is a convenience, never an error
  }
};
